import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { FiltersObject, isQueryParameter, VqlQuery } from "types";
import { useSelector } from "react-redux";
import { getIsNewFiltersPanel } from "redux/SingleDataset/selectors";
import { VQL_PARAMETER } from "helpers/constants/miscellaneous";
import { extractValuesFromVqlQueries } from "helpers/utility/vqlHelpers";

function useAllQueryParamsFilters(): FiltersObject {
  const { search } = useLocation();
  const isNewFiltersPanel = useSelector(getIsNewFiltersPanel);

  return useMemo(() => {
    const params = new URLSearchParams(search);
    const filtersObject: FiltersObject = {};

    // Process regular query parameters
    params.forEach((value, key) => {
      if (isQueryParameter(key)) {
        filtersObject[key] = decodeURIComponent(value);
      }
    });

    // If new filters panel is enabled, also extract values from VQL parameter
    if (isNewFiltersPanel) {
      const vqlParam = params.get(VQL_PARAMETER);
      if (vqlParam) {
        try {
          const vqlQueries = JSON.parse(vqlParam) as VqlQuery[];
          const extractedValues = extractValuesFromVqlQueries(vqlQueries);

          // Merge extracted values into filtersObject
          Object.assign(filtersObject, extractedValues);
        } catch (error) {
          console.error("Error parsing VQL parameter:", error);
        }
      }
    }

    return filtersObject;
  }, [search, isNewFiltersPanel]);
}

export default useAllQueryParamsFilters;
